import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { SwpToastService } from './shared/swp-components/swp-toast/swp-toast.service';
import { MessageService } from 'primeng/api';
import { DirByLangDirective } from '@/directives/dirByLang.directive';
import { AuthService } from '@/services/auth.service';

export const appInit = () => {
  const authService = inject(AuthService);
  return authService.refresh();
};

// DGF-exact blue: rgb(32,106,197) = hsl(213,72%,45%) — full scale derived from same hue/saturation
const DgfBluePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#edf4fc',
      100: '#d3e4f8',
      200: '#a7c8f1',
      300: '#7baced',
      400: '#478de1',
      500: '#206ac5', // ← DGF rgb(32,106,197)
      600: '#1a559e',
      700: '#134076',
      800: '#0d2b4f',
      900: '#081a30',
      950: '#05111f',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: DgfBluePreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(appInit),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding(),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
      lang: 'en',
    }),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    DatePipe,
    CurrencyPipe,
    MessageService,
    SwpToastService,
    DirByLangDirective,
  ],
};
